import apiClient from "@/app/api/client";
import type { Absence, AbsenceCreateInput, AbsenceReviewAction } from "../types";

interface SingleResponse<T> {
	success: true;
	data: T;
}

export const absencesService = {
	async create(input: AbsenceCreateInput): Promise<Absence> {
		const response = await apiClient.post<SingleResponse<Absence>>("/absences", input);

		return response.data.data;
	},

	async review(id: string, action: AbsenceReviewAction, reviewNote?: string): Promise<Absence> {
		const response = await apiClient.post<SingleResponse<Absence>>(`/absences/${id}/${action}`, {
			reviewNote,
		});

		return response.data.data;
	},

	/**
	 * Hujjatni BLOB sifatida oladi.
	 *
	 * ⚠️ `<a href="/api/v1/absences/…/document">` ISHLATILMAYDI: access
	 * token faqat JS xotirasida (`Authorization` sarlavhasi), cookie'da
	 * emas — oddiy havola 401 olardi.
	 */
	async downloadDocument(id: string): Promise<Blob> {
		const response = await apiClient.get<Blob>(`/absences/${id}/document`, {
			responseType: "blob",
		});

		return response.data;
	},
};
